import { render, staticRenderFns } from "./TriageCalculationResult.vue?vue&type=template&id=9845ee68"
import script from "./TriageCalculationResult.vue?vue&type=script&lang=ts"
export * from "./TriageCalculationResult.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports